export default {"src":"/_next/static/media/lines_graph_cell.1d21de02.svg","height":490,"width":1369,"blurWidth":0,"blurHeight":0};